import React from 'react';
import SEO from '../components/SEO';
import { useLanguage } from '../context/LanguageContext';
import { useTranslations } from '../utils/translationDictionaries';
import './MLS.css';

const MLS = () => {
  const { language } = useLanguage();
  const { t } = useTranslations(language);

  return (
    <div className="mls">
      <SEO
        title="MLS Puerto Rico | Alicea Realty Group LLC"
        description="Busque propiedades en el MLS de Puerto Rico con Alicea Realty Group LLC. Encuentre su propiedad ideal con Noemí Alicea González."
        keywords="MLS Puerto Rico, propiedades MLS, listados Puerto Rico, Alicea Realty Group, Noemi Alicea"
        ogTitle="MLS Puerto Rico | Alicea Realty Group LLC"
        ogDescription="Busque propiedades en el MLS de Puerto Rico con Alicea Realty Group LLC."
        ogImage="https://firebasestorage.googleapis.com/v0/b/realty-website-764ee.firebasestorage.app/o/web-media%2Farg_logo_nobg.png?alt=media&token=53b347a3-8d9e-4e5a-8a1f-64b7cbc32e69"
        canonical="https://www.alicearealtypr.com/mls"
      />

      <section className="mls-content">
        <div className="mls-iframe-container">
          <iframe
            src="https://properties.listingspuertorico.com/puerto-rico/userId_20945"
            title={t('mls.iframeTitle')}
            className="mls-iframe"
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
            allowFullScreen
          />
        </div>
      </section>
    </div>
  );
};

export default MLS;
